import { Outlet } from '@tanstack/react-router';
import { CommandPaletteProvider } from '../../context/command-palette-context';
import { CommandPalette } from '../command-palette/command-palette';
import { TopBarMenuProvider } from './top-bar-menu-context';
import { TopBar } from './top-bar';

function AppShell() {
  return (
    <div className="flex min-h-dvh flex-col" style={{ background: 'var(--color-base)' }}>
      <TopBar />
      <main className="flex flex-1 overflow-hidden">
        <Outlet />
      </main>
      <CommandPalette />
    </div>
  );
}

export function AppLayout() {
  return (
    <CommandPaletteProvider>
      <TopBarMenuProvider>
        <AppShell />
      </TopBarMenuProvider>
    </CommandPaletteProvider>
  );
}
